import * as React from 'react';

import user from 'js/lib/user';

import TopLevelModal from 'bundles/phoenix/components/TopLevelModal';
import EnterpriseEnrollmentChoiceModalForXDP from 'bundles/program-common/components/EnterpriseEnrollmentChoiceModalForXDP';
import { PRODUCT_TYPES } from 'bundles/program-common/constants/ProgramActionConstants';
import EnterpriseDisplayEnrollButton from 'bundles/unified-description-page-common/components/enroll/enterprise/EnterpriseDisplayEnrollButton';
import type { EnrollButtonSize } from 'bundles/unified-description-page-common/components/enroll/enterprise/enterpriseEnrollButtonOverrideStyles';
import { useAvailableEnrollmentOptions } from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseAvailableEnrollmentProgramsContext';
import { useEnterpriseCoursePageData } from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffCourseContext';
import { useEnterpriseSpecializationPageData } from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffSpecializationContext';

type Props = {
  enrollButtonRef?: React.MutableRefObject<HTMLDivElement | null>;
  shouldShowSponsoredByMessage?: boolean;
  size?: EnrollButtonSize;
  courseId?: string;
  privateSessionStart?: number;
  trackingOnClick?: () => void;
};

const EnterpriseMultiProgramEnrollButtonNotConfigurable = ({
  enrollButtonRef,
  size,
  courseId,
  privateSessionStart,
  shouldShowSponsoredByMessage,
  trackingOnClick,
}: Props) => {
  const [showModal, setShowModal] = React.useState(false);
  const coursePageData = useEnterpriseCoursePageData();
  const specializationPageData = useEnterpriseSpecializationPageData();
  const availableEnrollmentOptions = useAvailableEnrollmentOptions();

  if ((!coursePageData?.id && !specializationPageData?.id) || !user.isAuthenticatedUser()) {
    return null;
  }

  return (
    <React.Fragment>
      <EnterpriseDisplayEnrollButton
        courseId={courseId}
        privateSessionStart={privateSessionStart}
        size={size}
        shouldShowSponsoredByMessage={shouldShowSponsoredByMessage}
        onClick={() => {
          if (trackingOnClick) {
            trackingOnClick();
          }

          setShowModal(true);
        }}
        enrollButtonRef={enrollButtonRef}
        trackingName="multi_program_enroll_button"
        dataE2eName="multi-program-enroll-button"
      />
      {showModal && (
        <TopLevelModal>
          <EnterpriseEnrollmentChoiceModalForXDP
            productType={coursePageData?.id ? PRODUCT_TYPES.COURSE : PRODUCT_TYPES.SPECIALIZATION}
            productId={coursePageData?.id ? coursePageData.id : (specializationPageData?.id as string)}
            programs={availableEnrollmentOptions?.programs}
            invitedPrograms={availableEnrollmentOptions?.invitedPrograms}
            thirdPartyOrganizations={availableEnrollmentOptions?.thirdPartyOrganizations}
            invitedThirdPartyOrganizations={availableEnrollmentOptions?.invitedThirdPartyOrganizations}
            handleClose={() => setShowModal(false)}
            userId={user.get().id}
            waitForBothProgramDataFetch={false}
            courseSlug={coursePageData?.slug || specializationPageData?.courses?.[0]?.slug}
          />
        </TopLevelModal>
      )}
    </React.Fragment>
  );
};

export default EnterpriseMultiProgramEnrollButtonNotConfigurable;
